import React from 'react';
import { Navigate, useParams } from 'react-router-dom';

const ViewVideoProjectRedirect = () => {
    const { projectId } = useParams();
    return (
        <Navigate to={`/deliveries/${projectId}`} />
    );
};

export default ViewVideoProjectRedirect;